
import Vue from 'vue'
import Vuex from 'vuex'

import user from './user'
import permission from './async-router'
import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    permission
  },
  state: {

  },
  mutations: {

  },
  actions: {

  },
  getters
})


// WEBPACK FOOTER //
// ./src/store/index.js